export default __webpack_public_path__ + "static/media/440.2a3de9f0.gif";